/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SyncStatus } from './syncStatus';


/**
 * Data payload for \'appointment.sync_progress\' notifications.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AppointmentSyncProgressData { 
    appointmentId: number;
    completedSteps: number;
    totalSteps: number;
    currentStep: string;
    progress: string;
    isSyncing: boolean;
    syncStatus: SyncStatus;
}
export const AppointmentSyncProgressData_appointmentId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncProgressData_completedSteps_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncProgressData_totalSteps_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncProgressData_currentStep_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncProgressData_progress_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncProgressData_isSyncing_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncProgressData_syncStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];


